/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// Copies text with the async clipboard, falling back to a hidden textarea and execCommand where the clipboard
// API is missing or refused. Resolves to whether it worked.
export function copyText(text: string): Promise<boolean> {
  const fallback = (): boolean => {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try {
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      area.remove();
    }
  };
  return navigator.clipboard?.writeText
    ? navigator.clipboard.writeText(text).then(() => true, fallback)
    : Promise.resolve(fallback());
}
